export default __webpack_public_path__ + "static/media/Icon.e8daa8e6.png";